import React from 'react'
import PropTypes from 'prop-types'

import AuthenticationShell from 'shared/components/AuthenticationShell'
import { Button, Container, Divider, Form, Icon, Message } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

const CreateNewPassword = ({
  newPassword,
  confirmPassword,
  onNewPasswordChange,
  onConfirmPasswordChange,
  onSubmit,
  isPasswordError,
  errorMessage,
}) => (
  <AuthenticationShell headerText="Create a new password">
    {isPasswordError && (
      <Message negative>
        <strong>Whoops!</strong> {errorMessage}
      </Message>
    )}
    <Form onSubmit={onSubmit}>
      <Form.Field>
        <label>Password</label>
        <input
          value={newPassword}
          onChange={onNewPasswordChange}
          type="password"
          name="newPassword"
          required
        />
      </Form.Field>
      <Form.Field>
        <label>Confirm password</label>
        <input
          value={confirmPassword}
          onChange={onConfirmPasswordChange}
          type="password"
          name="confirmPassword"
          required
        />
      </Form.Field>

      <Button primary fluid onClick={onSubmit} disabled={isPasswordError}>
        Save password
      </Button>
    </Form>
    <Container textAlign="center">
      <Divider hidden />
      <Link to={{ pathname: '/login/', search: location.search }}>
        <Icon className="fas fa-arrow-left" />
        Back to login
      </Link>
    </Container>
  </AuthenticationShell>
)

CreateNewPassword.propTypes = {
  newPassword: PropTypes.string,
  confirmPassword: PropTypes.string,
  onNewPasswordChange: PropTypes.func,
  onConfirmPasswordChange: PropTypes.func,
  onSubmit: PropTypes.func,
  isPasswordError: PropTypes.bool,
}

export default CreateNewPassword



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/ResetPassword/CreateNewPassword.js